import * as React from 'react';
import {emotionStyled} from '@packages/utilities/styled';
import Hitarea from '../Hitarea';
import {FinePrint} from '../Text';
import {RadioContent} from '../Radio/RadioContent';
import {RadioHelpText} from '../Radio/RadioHelpText';
import {RadioInputIcon} from '../Radio/RadioInput';

type RadioSelectItemProps = {
  first?: boolean;
  label: string;
  last?: boolean;
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
  onSelect?: any;
  role: string;
  selected?: boolean;
  subtext?: string;
  tabIndex?: number;
};

const ItemView = emotionStyled('div')(
  {
    alignItems: 'flex-start',
    backgroundColor: '$background1',
    border: '$border1',
    cursor: 'default',
    display: 'flex',
    marginTop: -1,
    outline: '2px solid transparent',
    padding: '$2',
    position: 'relative',
    '&:hover': {
      backgroundColor: '$background2',
    },
  },
  {
    variants: {
      selected: {
        true: {
          borderColor: '$blueBorder',
          zIndex: 1,
        },
      },
      isFirst: {
        true: {
          borderTopLeftRadius: '$2',
          borderTopRightRadius: '$2',
        },
      },
      isLast: {
        true: {
          borderBottomLeftRadius: '$2',
          borderBottomRightRadius: '$2',
        },
      },
    },
  }
);

export function RadioSelectItem(props: RadioSelectItemProps) {
  const {first, last, label, subtext, selected, ...rest} = props;
  const itemRef = React.useRef<any>(null);

  React.useEffect(() => {
    if (selected) {
      itemRef.current.focus();
    }
  }, [selected]);

  return (
    <Hitarea>
      <ItemView
        {...rest}
        isFirst={first}
        isLast={last}
        selected={selected}
        ref={itemRef}
      >
        <RadioInputIcon checked={selected} />
        <RadioContent>
          <FinePrint>{label}</FinePrint>
          {subtext && <RadioHelpText>{subtext}</RadioHelpText>}
        </RadioContent>
      </ItemView>
    </Hitarea>
  );
}
